import axios from 'axios';
import { constructServiceURL } from '../../../../utils/URLTools';

export const apiFetchEdiRfidAuditRequests = () => {
  const serviceUrl = constructServiceURL({
    endpoint: 'getEdiRfidAuditRequests',
    stub: process.env.useStubbedEndpoints,
  });
  return axios.get(serviceUrl);
};

export const apiFetchEdiRfidAuditRequestExecutions = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'getEdiRfidAuditRequestExecutions',
    stub: process.env.useStubbedEndpoints,
    pathParameters: {
      requestId: payload.params.requestId,
    },
  });
  return axios.get(serviceUrl);
};
